import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import { Button, Table } from "react-bootstrap";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import { useLocation, useNavigate } from "react-router-dom";
import { DateIcon2, ExcelDownloadIcon, ExcelDownloadIcon1, PDFDownloadIcon, PDFDownloadIcon1 } from "../../icon/icon";
import {
  dateFormatDateWithTime,
  dateFormatting,
  DateUtility,
  downloadDataAsExcel,
  downloadDataAsPDF,
  fetchMediaData,
  notify,
} from "../../helpers/commonFunction";
import {
  Loader,
  CustomDateInput,
  CustomImageCard,
  CustomInfiniteScroll,
} from "../../components";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  reqToGetDMReportList,
  reqToGetAdminReportList,
  reqToGetTerritoryList,
  reqToGetDMRestaurantList,
  reqToGetAdminRestaurantList,
  reqToResetReportList,
  reqToGetDMAllReportList,
  reqToGetAdminAllReportList,
  reqToGetAdminUserReportList,
  reqToGetAdminUsersList,
  reqToGetAdminReportRestaurants,
  reqToUpdateAdminReportList,
} from "../../store/slice/reportSlice";
import { IMAGE_URL, routes } from "../../helpers/constants";
const MemoizedImageCard = React.memo(CustomImageCard);

const ReportsDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { reportType } = location?.state || {};
  const { user } = useSelector((state) => state?.userReducer);
  const {
    loader,
    listLoader,
    dmReportList,
    adminReportList,
    territoryList,
    restaurantList,
    totalReportCounts,
    adminUsers,
    adminUserReportList,
    adminRestaurantList
  } = useSelector(
    (state) => ({
      loader: state?.reportReducer?.loader,
      listLoader: state?.reportReducer?.listLoader,
      dmReportList: state?.reportReducer?.dmReportList,
      adminReportList: state?.reportReducer?.adminReportList,
      territoryList: state?.reportReducer?.territoryList,
      restaurantList: state?.reportReducer?.restaurantList,
      totalReportCounts: state?.reportReducer?.totalReportCounts,
      adminUsers: state?.reportReducer?.adminUsers,
      adminUserReportList: state?.reportReducer?.adminUserReportList,
      adminRestaurantList: state?.reportReducer?.adminRestaurantList
    }),
    shallowEqual
  );

  const currentDate = dateFormatting();
  const [selectedData, setSelectedData] = useState({
    sDate: currentDate,
    eDate: currentDate,
    territory_id: null,
    admin_user_id: null,
    admin_restaurant_id: null,
    restaurant: {
      label: "All Restaurants",
      value: null,
    },
  });
  const [isLoading, setIsLoading] = useState({
    pdf: false,
    excel: false,
  });
  const [newReportList, setNewReportList] = useState([]);
  const [restaurantCount, setRestaurantCount] = useState(0);
  const [adminUsersOptions, setAdminUsersOptions] = useState([]);
  const [selectedSubItem, setSelectedSubItem] = useState(null);
  const [adminUsersRestaurantsOptions, setAdminUsersRestaurantsOptions] = useState([]);

  const [territoryOptions, setTerritoryOptions] = useState([]);
  const [restaurantListOptions, setRestaurantListOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);

  useEffect(() => {
    if (!reportType) {
      if (user?.user_role === "DM") {
        navigate(routes.dmPortal);
      } else {
        navigate(routes.adminPortal);
      }
    } else {
      // handleGetInitialData();
    }
    getAdminUsersList({});
  }, []);

  const handleGetInitialData = async () => {
    if (user?.user_role === "DM") {
      getRestaurentList();
    } else {
      let initialTerritory = null;
      await dispatch(
        reqToGetTerritoryList({
          data: {
            type: reportType,
            start_date: selectedData.sDate,
            end_date: selectedData.eDate,
          },
          onSuccess: (res) => {
            if (Array.isArray(res) && res?.length > 0) {
              initialTerritory = {
                ...res[0],
                value: res[0]?.id,
                label: res[0]?.name,
              };
            }
            getRestaurentList(res[0]?.id, initialTerritory);
          },
          dispatch,
        })
      );
    }
  };

  const getAdminUsersList = () => {
    dispatch(reqToGetAdminUsersList({
      data: {}, onSuccess: (res) => {
        setSelectedData((prev) => ({ ...prev, admin_user_id: { value: res[0]?.id, label: res[0]?.user } }));
        const reqObj = {
          id: res[0]?.id
        }
        getAdminRestaurants(reqObj);
      }, onFailure: () => { }, dispatch
    }))
  }

  const getFirstItem = (res) => {
    if (!Array.isArray(res) || res.length === 0) return null;

    for (const restaurant of res) {
      for (const location of restaurant.location || []) {
        if (Array.isArray(location.items) && location.items.length > 0) {
          return location.items[0]; // 🎯 first item
        }
      }
    }

    return null;
  };

  const getAdminuserReportList = (reqObj) => {
    dispatch(reqToGetAdminUserReportList(
      {
        data: reqObj, onSuccess: (res) => {

          const firstSubItem = getFirstItem(res?.data);

          setSelectedSubItem(firstSubItem);
        }, onFailure: () => {

        }, dispatch
      }
    ))
  }

  const getAdminRestaurants = (data) => {
    dispatch(reqToGetAdminReportRestaurants({
      data: data, onSuccess: (res) => {
        const reqObj = {
          user_id: data?.id,
          restaurant_id: res[0]?.id,
          start_date: selectedData?.sDate,
          end_date: selectedData?.eDate,
        }

        setSelectedData((prev) => ({ ...prev, admin_restaurant_id: { value: res[0]?.id || null, label: res[0]?.name || "Select..." } }));
        if (Array.isArray(res) && res?.length !== 0) {
          getAdminuserReportList(reqObj);
        } else {
          dispatch(reqToUpdateAdminReportList([]));
        }

      }, onFailure: () => { }, dispatch
    }))
  }



  const getRestaurentList = (tmId, initialTerritory) => {
    if (user?.user_role === "DM") {
      dispatch(
        reqToGetDMRestaurantList({
          data: {},
          onSuccess: (res) => {
            let reqObj = {
              type: reportType,
              start_date: selectedData?.sDate,
              end_date: selectedData?.eDate,
              page: 1,
              limit: 10,
            };
            if (reportType === "USER") {
              reqObj["restaurant_id"] = getRestaurantIds(
                selectedData?.restaurant?.value,
                true,
                res
              );
            } else {
              reqObj["restaurant_id"] = [];
            }
            // fetchReportList(reqObj, true);
          },
          onFailure: () => { },
          dispatch,
        })
      );
    } else {
      dispatch(
        reqToGetAdminRestaurantList({
          data: { territory_id: tmId },
          onSuccess: (res) => {
            let reqObj = {
              type: reportType,
              territory_id: initialTerritory?.value || null,
              start_date: selectedData?.sDate,
              end_date: selectedData?.eDate,
              page: 1,
              limit: 10,
            };
            if (reportType === "USER") {
              reqObj["restaurant_id"] = getRestaurantIds(
                selectedData?.restaurant?.value,
                true,
                res
              );
            } else {
              reqObj["restaurant_id"] = [];
            }
            setSelectedData((prev) => ({
              ...prev,
              territory_id: initialTerritory,
            }));
            // fetchReportList(reqObj, true);
          },
          onFailure: () => { },
          dispatch,
        })
      );
    }
  };

  const getAdminUsersOptioons = useCallback(() => {
    const adminUsersOption =
      (Array.isArray(adminUsers) &&
        adminUsers?.length > 0 &&
        adminUsers?.map((item) => {
          return {
            ...item,
            value: item?.id,
            label: item?.user,
          };
        })) ||
      [];
    setAdminUsersOptions(adminUsersOption);
  }, [adminUsers]);

  const getAdminUsersRestaurantsOptioons = useCallback(() => {
    const adminUsersOption =
      (Array.isArray(adminRestaurantList) &&
        adminRestaurantList?.length > 0 &&
        adminRestaurantList?.map((item) => {
          return {
            ...item,
            value: item?.id,
            label: item?.name,
          };
        })) ||
      [];
    setAdminUsersRestaurantsOptions(adminUsersOption);
  }, [adminRestaurantList]);

  useEffect(() => {
    getAdminUsersOptioons()
  }, [adminUsers]);

  useEffect(() => {
    getAdminUsersRestaurantsOptioons();
  }, [adminRestaurantList])

  useEffect(() => {
    getTerritoryListOptions();
  }, [territoryList]);

  useEffect(() => {
    getRestaurantListOptions();
  }, [restaurantList]);

  const getRestaurantIds = (sValue, init, mainArray) => {
    if (!sValue) {
      if (init) {
        return mainArray.map((user) => user.id);
      } else {
        return restaurantList.map((user) => user.id);
      }
    } else {
      const sUser = restaurantList.find((user) => user.id === sValue);
      return sUser ? [sUser.id] : [];
    }
  };

  useEffect(() => {
    if (user?.user_role === "DM") {
      setNewReportList(dmReportList);
    } else {
      setNewReportList(adminReportList);
    }
    const initialData =
      user?.user_role === "DM" ? dmReportList : adminReportList;
    if (
      reportType === "USER" &&
      Array.isArray(initialData) &&
      initialData?.length > 0
    ) {
      const uniqueRestaurants = [];
      const seen = new Set();
      for (const item of initialData) {
        if (!seen.has(item.restaurant)) {
          seen.add(item.restaurant);
          uniqueRestaurants.push(item);
        }
      }
      setRestaurantCount(uniqueRestaurants?.length);
    }
  }, [dmReportList, adminReportList]);

  const getTerritoryListOptions = useCallback(() => {
    const territoryListOption =
      (Array.isArray(territoryList) &&
        territoryList?.length > 0 &&
        territoryList?.map((item) => {
          return {
            ...item,
            value: item?.id,
            label: item?.name,
          };
        })) ||
      [];
    setTerritoryOptions(territoryListOption);
  }, [territoryList]);

  const getRestaurantListOptions = useCallback(() => {
    const restaurantOption =
      (Array.isArray(restaurantList) &&
        restaurantList?.length > 0 &&
        restaurantList?.map((item) => {
          return {
            ...item,
            value: item?.id,
            label: item?.restaurant,
          };
        })) ||
      [];

    restaurantOption.unshift({
      label: "All Restaurants",
      value: null,
    });
    setRestaurantListOptions(restaurantOption);
  }, [restaurantList]);

  const handleChangeValues = (event, type, name) => {
    setPage(1);
    setHasMoreData(true);
    dispatch(reqToResetReportList([]));
    if (type === "option") {
      if (name === "territory") {
        setSelectedData((prev) => ({ ...prev, territory_id: event }));
        const reqObj = {
          type: reportType,
          start_date: selectedData?.sDate,
          end_date: selectedData?.eDate,
          territory_id: event,
        };
        fetchReportList(reqObj);
      } else if (name === "restaurant") {
        setSelectedData((prev) => ({ ...prev, restaurant: event }));
        const reqObj = {
          type: reportType,
          start_date: selectedData?.sDate,
          end_date: selectedData?.eDate,
          restaurant: event,
        };
        fetchReportList(reqObj);
      } else if (name === "admin_user_id") {
        setSelectedData((prev) => ({ ...prev, admin_user_id: event }));
        const reqObj = {
          id: event?.value
        }
        getAdminRestaurants(reqObj);
      } else if (name === "admin_restaurant_id") {
        setSelectedData((prev) => ({ ...prev, admin_restaurant_id: event }));

        const reqObj = {
          user_id: selectedData?.admin_user_id?.value,
          restaurant_id: event?.value,
          start_date: selectedData?.sDate,
          end_date: selectedData?.eDate,
        }

        getAdminuserReportList(reqObj)
      }
    } else if (type === "date") {
      if (name === "sDate") {
        setSelectedData({
          ...selectedData,
          sDate: event,
          restaurant: {
            label: "All Restaurants",
            value: null,
          },
        });
        if (!selectedData?.admin_restaurant_id?.value) return;

        const reqObj = {
          type: reportType,
          sDate: event,
          eDate: selectedData?.eDate,
        };
        // fetchReportList(reqObj);
        const reqObj1 = {
          user_id: selectedData?.admin_user_id?.value,
          restaurant_id: selectedData?.admin_restaurant_id?.value,
          start_date: event,
          end_date: selectedData?.eDate,
        }

        getAdminuserReportList(reqObj1)

      } else if (name === "eDate") {
        setSelectedData({
          ...selectedData,
          eDate: event,
          restaurant: {
            label: "All Restaurants",
            value: null,
          },
        });
        if (!selectedData?.admin_restaurant_id?.value) return;

        const reqObj = {
          type: reportType,
          sDate: selectedData?.sDate,
          eDate: event,
        };
        // fetchReportList(reqObj);

        const reqObj1 = {
          user_id: selectedData?.admin_user_id?.value,
          restaurant_id: selectedData?.admin_restaurant_id?.value,
          start_date: selectedData?.sDate,
          end_date: event,
        }

        getAdminuserReportList(reqObj1)
      }
    }
  };

  const fetchReportList = (reqObj, initial = false) => {
    if (user?.user_role === "DM") {
      let newReqObj = {
        type: reportType,
        start_date: reqObj?.sDate || selectedData?.sDate,
        end_date: reqObj?.eDate || selectedData?.eDate,
        restaurant_id: reqObj?.restaurant?.value
          ? getRestaurantIds(reqObj?.restaurant?.value)
          : getRestaurantIds(selectedData?.restaurant?.value),
        page: reqObj.page || 1,
        limit: 10,
      };
      if (reportType === "USER") {
        newReqObj["restaurant_id"] = reqObj?.restaurant?.value
          ? getRestaurantIds(reqObj?.restaurant?.value)
          : getRestaurantIds(selectedData?.restaurant?.value);
      } else {
        newReqObj["restaurant_id"] = [];
      }
      dispatch(
        reqToGetDMReportList({
          data: initial ? reqObj : newReqObj,
          dispatch,
        })
      );
    } else {
      const newReqObj = {
        type: reportType,
        territory_id:
          reqObj?.territory_id?.value || selectedData?.territory_id?.value,
        start_date: reqObj.sDate || selectedData?.sDate,
        end_date: reqObj.eDate || selectedData?.eDate,
        page: reqObj.page || 1,
        limit: 10,
      };
      if (reportType === "USER") {
        newReqObj["restaurant_id"] = reqObj?.restaurant?.value
          ? getRestaurantIds(reqObj?.restaurant?.value)
          : getRestaurantIds(selectedData?.restaurant?.value);
      } else {
        newReqObj["restaurant_id"] = [];
      }
      dispatch(
        reqToGetAdminReportList({
          data: initial ? reqObj : newReqObj,
          dispatch,
        })
      );
    }
  };


  const getItemRowCount = (item) =>
    item.sub_items?.length || 1;

  const getLocationRowCount = (location) =>
    location.items.reduce(
      (sum, item) => sum + getItemRowCount(item),
      0
    );

  const getLatestReport = (reports = []) =>
    reports.length
      ? reports.reduce((a, b) =>
        new Date(b.record_date) > new Date(a.record_date) ? b : a
      )
      : null;

  const getLatestByStatus = (reports = [], status) =>
    reports
      .filter(r => r.status === status)
      .reduce((latest, curr) => {
        if (!latest) return curr;
        return new Date(curr.record_date) > new Date(latest.record_date)
          ? curr
          : latest;
      }, null);


  const downloadAsPDf = async (adminUserReportList) => {
    try {
      setIsLoading((prev) => ({ ...prev, pdf: true }));

      if (!Array.isArray(adminUserReportList) || !adminUserReportList.length) {
        throw new Error("Data not found!");
      }

      const headers = [
        "No",
        "Items",
        "Location",
        "Activity",
        "Date",
        "Day",
        "Before",
        "In Progress",
        "After",
        "Add Notes",
        "Attachment",
        "Personnel",
      ];

      const columns = headers.map((h, i) => ({
        header: h,
        dataKey: i,
      }));

      const pdfRows = [];
      let rowIndex = 1;

      for (const site of adminUserReportList) {
        for (const location of site.location || []) {
          for (const item of location.items || []) {

            const dates = getItemDates(item.sub_items);

            for (const date of dates) {

              for (const subItem of item.sub_items || []) {

                const reports = subItem.item_report || [];

                const beforeReport = getReport(reports, "before", date);
                const processingReport = getReport(reports, "processing", date);
                const afterReport = getReport(reports, "after", date);

                const beforeImg =
                  beforeReport?.image
                    ? {
                      image: await fetchMediaData(
                        IMAGE_URL + beforeReport.image,
                        true
                      ),
                      text: DateUtility.fullDateTime(beforeReport.record_date),
                    }
                    : "-";

                const processingImg =
                  processingReport?.image
                    ? {
                      image: await fetchMediaData(
                        IMAGE_URL + processingReport.image,
                        true
                      ),
                      text: DateUtility.fullDateTime(
                        processingReport.record_date
                      ),
                    }
                    : "-";

                const afterImg =
                  afterReport?.image
                    ? {
                      image: await fetchMediaData(
                        IMAGE_URL + afterReport.image,
                        true
                      ),
                      text: DateUtility.fullDateTime(afterReport.record_date),
                    }
                    : "-";

                const attachmentImg =
                  subItem?.attachments
                    ? await fetchMediaData(
                      IMAGE_URL + subItem.attachments,
                      true
                    )
                    : "-";

                const row = [
                  rowIndex++,
                  item.name || "-",
                  location.name || "-",
                  subItem.name || "-",
                  DateUtility.dayMonthYear3(date),
                  new Date(date).toLocaleDateString("en-US", {
                    weekday: "long",
                  }),
                  beforeImg,
                  processingImg,
                  afterImg,
                  subItem?.notes || "-",
                  attachmentImg,
                  selectedData?.admin_user_id?.label || "-",
                ];

                pdfRows.push(row);
              }
            }
          }
        }
      }

      const rows = pdfRows.map((row) => {
        const obj = {};
        row.forEach((val, idx) => {
          obj[idx] = val;
        });
        return obj;
      });

      const imageColumnIndexes = [6, 7, 8, 10];

      await downloadDataAsPDF(
        columns,
        rows,
        "Activity_Report.pdf",
        imageColumnIndexes,
        30,
        6
      );

      setIsLoading((prev) => ({ ...prev, pdf: false }));

    } catch (error) {
      console.error(error);
      setIsLoading((prev) => ({ ...prev, pdf: false }));
    }
  };

  const getItemDates = (subItems = []) => {
    const set = new Set();

    subItems.forEach((sub) => {
      (sub.item_report || []).forEach((r) => {
        const key = new Date(r.record_date).toISOString().split("T")[0];
        set.add(key);
      });
    });

    return Array.from(set).sort();
  };

  const getReport = (reports, status, date) => {
    return (reports || []).find(
      (r) =>
        r.status === status &&
        new Date(r.record_date).toISOString().split("T")[0] === date
    );
  };


  const downloadAsExcel = (adminUserReportList) => {
    try {
      setIsLoading((prev) => ({ ...prev, excel: true }));

      if (!Array.isArray(adminUserReportList) || !adminUserReportList.length) {
        throw new Error("Data not found!");
      }

      const headers = [
        "No",
        "Items",
        "Location",
        "Activity",
        "Date",
        "Day",
        "Before",
        "In Progress",
        "After",
        "Add Notes",
        "Attachment",
        "Personnel",
      ];

      const excelRows = [];
      let rowIndex = 1;

      adminUserReportList.forEach((site) => {
        site.location?.forEach((location) => {
          location.items?.forEach((item) => {

            const dates = getItemDates(item.sub_items);

            dates.forEach((date) => {

              item.sub_items?.forEach((subItem) => {

                const reports = subItem.item_report || [];

                const beforeReport = getReport(reports, "before", date);
                const processingReport = getReport(reports, "processing", date);
                const afterReport = getReport(reports, "after", date);

                excelRows.push([
                  rowIndex++,
                  item.name || "-",
                  location.name || "-",
                  subItem.name || "-",

                  DateUtility.dayMonthYear3(date),

                  new Date(date).toLocaleDateString("en-US", {
                    weekday: "long",
                  }),

                  beforeReport?.image
                    ? {
                      v: `${IMAGE_URL + beforeReport.image}\n${DateUtility.fullDateTime(
                        beforeReport.record_date
                      )}`,
                      l: { Target: IMAGE_URL + beforeReport.image },
                    }
                    : "-",

                  processingReport?.image
                    ? {
                      v: `${IMAGE_URL + processingReport.image}\n${DateUtility.fullDateTime(
                        processingReport.record_date
                      )}`,
                      l: { Target: IMAGE_URL + processingReport.image },
                    }
                    : "-",

                  afterReport?.image
                    ? {
                      v: `${IMAGE_URL + afterReport.image}\n${DateUtility.fullDateTime(
                        afterReport.record_date
                      )}`,
                      l: { Target: IMAGE_URL + afterReport.image },
                    }
                    : "-",

                  subItem?.notes || "-",

                  subItem?.attachments
                    ? {
                      v: IMAGE_URL + subItem.attachments,
                      l: { Target: IMAGE_URL + subItem.attachments },
                    }
                    : "-",

                  selectedData?.admin_user_id?.label || "-",
                ]);

              });

              rowIndex++;
            });

          });
        });
      });

      downloadDataAsExcel(
        [[headers, ...excelRows]],
        ["Activity Report"],
        "Activity_Report.xlsx"
      );

      setTimeout(() => {
        setIsLoading((prev) => ({ ...prev, excel: false }));
      }, 200);

    } catch (error) {
      notify(error?.message || "Something went wrong when downloading excel!");
      setIsLoading((prev) => ({ ...prev, excel: false }));
    }
  };


  const downLoadExcelOrPdfFile = (fileType) => {
    if (user?.user_role === "DM") {
      let newReqObj = {
        type: reportType,
        start_date: selectedData?.sDate,
        end_date: selectedData?.eDate,
        restaurant_id: getRestaurantIds(selectedData?.restaurant?.value),
        page: 1,
        limit: 0,
      };
      if (reportType === "USER") {
        newReqObj["restaurant_id"] = getRestaurantIds(
          selectedData?.restaurant?.value
        );
      } else {
        newReqObj["restaurant_id"] = [];
      }
      dispatch(
        reqToGetDMAllReportList({
          data: newReqObj,
          onSuccess: (res) => {
            if (fileType === "pdf") {
              downloadAsPDf(res?.list);
            } else {
              downloadAsExcel(res?.list);
            }
          },
          dispatch,
        })
      );
    } else {
      const newReqObj = {
        type: reportType,
        territory_id: selectedData?.territory_id?.value,
        start_date: selectedData?.sDate,
        end_date: selectedData?.eDate,
        page: 1,
        limit: 0,
      };
      if (reportType === "USER") {
        newReqObj["restaurant_id"] = getRestaurantIds(
          selectedData?.restaurant?.value
        );
      } else {
        newReqObj["restaurant_id"] = [];
      }
      dispatch(
        reqToGetAdminAllReportList({
          data: newReqObj,
          onSuccess: (res) => {
            if (fileType === "pdf") {
              downloadAsPDf(res?.list);
            } else {
              downloadAsExcel(res?.list);
            }
          },
          dispatch,
        })
      );
    }
  };

  const loadMoreReportList = () => {
    if (newReportList && newReportList?.length === totalReportCounts) {
      setPage(1);
      // setHasMoreData(false);
    } else {
      const tempObj = {
        user_id: getRestaurantIds(selectedData.restaurant),
        start: selectedData.sDate,
        end: selectedData.eDate,
        page: page + 1,
        search: "",
      };
      setPage(page + 1);
      fetchReportList(tempObj);
    }
  };

  const hasReportData = () => {
    return Array.isArray(adminUserReportList) &&
      adminUserReportList.length > 0 &&
      adminUserReportList.some(site =>
        site.location?.some(loc =>
          loc.items?.some(item => item.sub_items?.length)
        )
      ) && adminUserReportList.some(site =>
        site.location?.some(loc =>
          loc.items?.some(item => item.sub_items?.some((x) => x.item_report?.length))
        )
      );
  };



  return (
    <>
      {(loader || isLoading?.pdf || isLoading?.excel || listLoader) && <Loader />}
      <div className="tc-calls-container tc-calls-details-container h-100">
        <div className="row mb-2">
          <div className="col-12 col-md-6 col-lg-3 col-xxl-2 mb-2 mb-xxl-0">
            <span>FTS Personnel:</span>
            <Select
              id="admin_user_id"
              name="admin_user_id"
              value={selectedData?.admin_user_id}
              onChange={(e) => handleChangeValues(e, "option", "admin_user_id")}
              options={adminUsersOptions}
              classNamePrefix="select"
              placeholder="Select..."
            />
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-2 mb-2 mb-xxl-0">
            <span>Company:</span>
            <Select
              id="admin_restaurant_id"
              name="admin_restaurant_id"
              value={selectedData?.admin_restaurant_id}
              onChange={(e) => handleChangeValues(e, "option", "admin_restaurant_id")}
              options={adminUsersRestaurantsOptions}
              classNamePrefix="select"
              placeholder="Select..."
            />
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-2 mb-2 mb-xxl-0">
            <span>DATE FROM:</span>
            <ReactDatePicker
              selected={moment(selectedData?.sDate)._d}
              onChange={(e) =>
                handleChangeValues(
                  moment(e).format("YYYY-MM-DD"),
                  "date",
                  "sDate"
                )
              }
              id="date-picker-md"
              dateFormat="yyyy-MM-dd"
              value={moment(selectedData?.sDate).format("LL")}
              maxDate={moment(selectedData?.eDate)._d}
              onKeyDown={(e) => e.preventDefault()}
              customInput={
                <CustomDateInput className="bg-white" icon={DateIcon2} />
              }
            />
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-2 mb-2 mb-xxl-0">
            <span>DATE TO:</span>
            <ReactDatePicker
              selected={moment(selectedData?.eDate)._d}
              onChange={(e) =>
                handleChangeValues(
                  moment(e).format("YYYY-MM-DD"),
                  "date",
                  "eDate"
                )
              }
              id="date-picker-md"
              dateFormat="yyyy-MM-dd"
              value={moment(selectedData?.eDate).format("LL")}
              minDate={moment(selectedData?.sDate)._d}
              maxDate={moment().clone().endOf("month")._d}
              onKeyDown={(e) => e.preventDefault()}
              customInput={
                <CustomDateInput className="bg-white" icon={DateIcon2} />
              }
            />
          </div>
        </div>
        <div
          className="tc-table-wrapper tcl-report-wrapper mt-3"
          id="calls_box"
        >
          <div className="row w-100 h-100 mx-0 tcl-report-table">

            <div className="col-12 tcl-report-table-heading h-100 p-0">
              <div className="table-title py-2">
                <h6 className={`m-0 ${!hasReportData() ? "table-title-h6" : ""}`}>REPORTS</h6>
                {hasReportData() && (
                  <div className="table-title-btns">
                    <button className="download-btn" onClick={() => downloadAsPDf(adminUserReportList)}>Download {PDFDownloadIcon1}</button>
                    <button className="download-btn" onClick={() => downloadAsExcel(adminUserReportList)}>Download {ExcelDownloadIcon1}</button>
                  </div>
                )}
              </div>
              <Table responsive className="tc-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Items</th>
                    <th>Location</th>
                    <th>Activity</th>
                    <th>Date</th>
                    <th>Day</th>
                    <th>Before</th>
                    <th>In Progress</th>
                    <th>After</th>
                    <th>Add Notes</th>
                    <th>Attachment</th>
                    <th>Personnel</th>
                  </tr>
                </thead>

                <tbody>

                  {!hasReportData() ? (

                    <tr>
                      <td colSpan={12} className="text-center">
                        Data Not Found
                      </td>
                    </tr>

                  ) : (

                    (() => {

                      let rowCounter = 0;

                      return adminUserReportList.map((site) =>
                        site.location.map((location) =>
                          location.items.map((item) => {

                            const dates = getItemDates(item.sub_items);

                            return dates.flatMap((date) =>
                              item.sub_items.map((subItem, subIndex) => {

                                const isFirstRow = subIndex === 0;

                                const reports = subItem.item_report || [];

                                const before = getReport(reports, "before", date);
                                const processing = getReport(reports, "processing", date);
                                const after = getReport(reports, "after", date);

                                return (
                                  <tr key={`${location.id}-${item.id}-${date}-${subItem.id}`}>

                                    {isFirstRow && (
                                      <td rowSpan={item.sub_items.length}>
                                        {++rowCounter}
                                      </td>
                                    )}

                                    {isFirstRow && (
                                      <td rowSpan={item.sub_items.length}>
                                        {item.name}
                                      </td>
                                    )}

                                    {isFirstRow && (
                                      <td rowSpan={item.sub_items.length}>
                                        {location.name}
                                      </td>
                                    )}

                                    <td>{subItem.name}</td>

                                    <td className="white_space_nowrap">
                                      {DateUtility.dayMonthYear3(date)}
                                    </td>

                                    <td className="white_space_nowrap">
                                      {new Date(date).toLocaleDateString("en-US", {
                                        weekday: "long",
                                      })}
                                    </td>

                                    <td className="media-cell">
                                      {before ? (
                                        <>
                                          {before.image ? (
                                            <MemoizedImageCard
                                              src={IMAGE_URL + before.image}
                                              width={100}
                                              imagePreview
                                            />
                                          ) : "-"}
                                          <small className="white_space_nowrap">
                                            {DateUtility.fullDateTime(before.record_date)}
                                          </small>
                                        </>
                                      ) : "-"}
                                    </td>

                                    <td className="media-cell">
                                      {processing ? (
                                        <>
                                          {processing.image ? (
                                            <MemoizedImageCard
                                              src={IMAGE_URL + processing.image}
                                              width={100}
                                              imagePreview
                                            />
                                          ) : "-"}
                                          <small className="white_space_nowrap">
                                            {DateUtility.fullDateTime(processing.record_date)}
                                          </small>
                                        </>
                                      ) : "-"}
                                    </td>

                                    <td className="media-cell">
                                      {after ? (
                                        <>
                                          {after.image ? (
                                            <MemoizedImageCard
                                              src={IMAGE_URL + after.image}
                                              width={100}
                                              imagePreview
                                            />
                                          ) : "-"}
                                          <small className="white_space_nowrap">
                                            {DateUtility.fullDateTime(after.record_date)}
                                          </small>
                                        </>
                                      ) : "-"}
                                    </td>

                                    <td>
                                      <strong>{subItem?.notes || "-"}</strong>
                                    </td>

                                    <td>
                                      {subItem?.attachments ? (
                                        <MemoizedImageCard
                                          src={IMAGE_URL + subItem.attachments}
                                          width={100}
                                          imagePreview
                                        />
                                      ) : "-"}
                                    </td>

                                    {isFirstRow && (
                                      <td rowSpan={item.sub_items.length}>
                                        {selectedData?.admin_user_id?.label}
                                      </td>
                                    )}

                                  </tr>
                                );

                              })
                            );

                          })
                        )
                      );

                    })()

                  )}

                </tbody>
              </Table>
            </div>
          </div>

          {/* <CustomInfiniteScroll
            dataLength={newReportList}
            hasMore={hasMoreData}
            next={loadMoreReportList}
            scrollableTarget="calls_box"
          >
            <Table responsive className="tc-table">
              <thead>
                <tr>
                  <th>SCHEDULE</th>
                  <th>
                    {reportType === "USER"
                      ? "RESTAURANT PERSONNEL"
                      : reportType === "FTS"
                      ? "FTS Personnel"
                      : reportType === "AUDITOR"
                      ? "Rx Agad Auditor"
                      : "Rx Agad Lab Personnel"}
                  </th>
                  <th>DATE/TIME</th>
                  <th>LOCATION</th>
                  {Array.isArray(newReportList) && newReportList.length > 0 ? (
                    (() => {
                      const maxAttachments = Math.max(
                        ...newReportList.map((item) =>
                          item.images && typeof item.images === "string"
                            ? Array.isArray(JSON.parse(item.images))
                              ? JSON.parse(item.images)?.length
                              : 0
                            : Array.isArray(item.images)
                            ? item.images?.length
                            : 0
                        )
                      );
                      if (reportType === "FTS") {
                        return (
                          <>
                            <th>Grease Trap</th>
                            <th>Clean the Basket</th>
                            <th>Scoop</th>
                            <th>Dosing</th>
                          </>
                        );
                      } else {
                        return Array.from(
                          { length: maxAttachments },
                          (_, index) => (
                            <th key={`attachment-${index}`}>
                              ATTACHMENT {index + 1}
                            </th>
                          )
                        );
                      }
                    })()
                  ) : reportType === "FTS" ? (
                    <>
                      <th>Grease Trap</th>
                      <th>Clean the Basket</th>
                      <th>Scoop</th>
                      <th>Dosing</th>
                    </>
                  ) : (
                    <th>ATTACHMENT 1</th>
                  )}
                </tr>
              </thead>
              {!Array.isArray(newReportList) || newReportList?.length === 0 ? (
                <tbody>
                  <tr>
                    <td
                      className="text-center"
                      colSpan={reportType === "FTS" ? 8 : 5}
                    >
                      No data found
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {newReportList?.map((item, i) => {
                    const imagesArr =
                      item?.images && typeof item?.images === "string"
                        ? Array.isArray(JSON.parse(item?.images))
                          ? JSON.parse(item?.images)
                          : []
                        : Array.isArray(item?.images)
                        ? item?.images
                        : [];

                    const maxAttachments =
                      reportType === "FTS"
                        ? 4
                        : Math.max(
                            ...newReportList.map((itm) =>
                              itm.images && typeof itm.images === "string"
                                ? Array.isArray(JSON.parse(itm.images))
                                  ? JSON.parse(itm.images)?.length
                                  : 0
                                : Array.isArray(itm.images)
                                ? itm.images?.length
                                : 0
                            )
                          );
                    return (
                      <tr key={i}>
                        <td className="min-width-200">
                          {item?.recode_time
                            ? moment(item?.recode_time).format("MM/DD/YY - ddd")
                            : "-"}
                        </td>
                        <td>{item?.restaurant || "-"}</td>
                        <td className="min-width-200">
                          {dateFormatDateWithTime(
                            item?.recode_time || new Date()
                          )}
                        </td>
                        <td className="min-width-400">
                          {item?.address || "-"}
                        </td>
                        {Array.from({ length: maxAttachments }, (_, index) => (
                          <td key={`attachment-${i}-${index}`}>
                            {imagesArr?.[index]?.image_url ? (
                              <span role="button">
                                <MemoizedImageCard
                                  src={
                                    process.env.REACT_APP_IMAGE_URL +
                                    imagesArr[index]?.image_url
                                  }
                                  alt={`Attachment ${index + 1}`}
                                  width={100}
                                  imagePreview={true}
                                />
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </Table>
          </CustomInfiniteScroll> */}
        </div>
      </div>
    </>
  );
};

export default ReportsDetails;
